import React, { useEffect } from 'react';
import '../../styles/Notification.css';

const Notification = ({ message, isError, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        },4000); 

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={`notification ${isError ? 'error' : 'success'}`}>
            <span>{message}</span>
            <button className="close-button" onClick={onClose}>&times;</button>
        </div>
    );
};

export default Notification;
